import React from "react";
import { RouteObject } from "react-router";

// '/screenshares/*'
export const ScreenshareRoutes: RouteObject[] = [
  {
    path: "join",
    async lazy() {
      const { ScreenShareJoin } = await import("customer/ScreenShare/ScreenShareJoin");
      return { element: <ScreenShareJoin /> };
    },
  },
  {
    path: ":roomUid",
    async lazy() {
      const { ScreenShareId } = await import("customer/ScreenShare/ScreenShareId");
      return { element: <ScreenShareId /> };
    },
  },
];
